export const SUPPORTED_LANGS = ["pl", "en"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export const ROUTE_SLUGS = {
	settings: { pl: "ustawienia", en: "settings" },
	meters: { pl: "liczniki", en: "meters" },
	waterMeters: { pl: "wodomierze", en: "water-meters" },
	heatMeters: { pl: "cieplomierze", en: "heat-meters" },
	electricityMeters: { pl: "liczniki-energii", en: "electricity-meters" },
	districts: { pl: "osiedla", en: "districts" },
	managers: { pl: "zarzadcy", en: "managers" },
	sources: { pl: "bramki", en: "gateways" },
	readings: { pl: "odczyty", en: "readings" },
	resellers: { pl: "resellerzy", en: "resellers" },
	myApartments: { pl: "moje-mieszkania", en: "my-apartments" },
	apartments: { pl: "lokale", en: "apartments" },
	activateApartment: { pl: "aktywuj-mieszkanie", en: "activate-apartment" },
	alerts: { pl: "alerty", en: "alerts" },
	keys: { pl: "klucze", en: "keys" },
	mediaTransmitters: { pl: "nadajniki-mediow", en: "media-transmitters" },
	detectedMeters: { pl: "wykryte-liczniki", en: "detected-meters" },
	deploymentReport: { pl: "raport-wdrozenia", en: "deployment-report" },
	designSystem: { pl: "design-system", en: "design-system" },
} as const;

export type RouteKey = keyof typeof ROUTE_SLUGS;

export function isValidLang(lang: string): lang is Lang {
	return (SUPPORTED_LANGS as readonly string[]).includes(lang);
}

export function findRouteKey(slug: string, lang: Lang): RouteKey | null {
	for (const [key, slugs] of Object.entries(ROUTE_SLUGS)) {
		if (slugs[lang] === slug) return key as RouteKey;
	}
	return null;
}

export function detectLang(): Lang {
	const saved = localStorage.getItem("language");
	if (saved && isValidLang(saved)) return saved;
	const browser = navigator.language.split("-")[0];
	if (isValidLang(browser)) return browser;
	return "pl";
}
